import { Card, CardImg, CardTitle } from 'reactstrap';
import styled from 'styled-components';




export const StyledCard = styled(Card).attrs(() => ({
  className: 'border-0  border-purple'
}))``

export const StyledHeader = styled.div`color: white;
font-family:'Lato', sans-serif;
font-size: 1.3em;`

export const StyledParentContainer = styled.div.attrs(() => ({
  className: 'commonFeature'
}))``

export const StyledCardImage = styled(CardImg).attrs((props) => ({
  className: "w-full h-48 md:h-64 sm:h-46 xs:h-54 object-cover",
  top: true,
  width: "100%",
  alt: "child img"
}))`
  
`

export const StyledCardTitle = styled.p.attrs()`font-family: 'Lato', sans-serif;`


const style = {
  cardView: {
    // boxShadow: "0 17px 23px -13px #E6E6E6",
    borderBottomLeftRadius: "20px",
    borderBottomRightRadius: "20px",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    borderColor: "#fff",
  },
  cardChild: {
    borderTopLeftRadius: "18px",
    borderTopRightRadius: "18px",
    objectFit: 'cover',
  },
  cardChildB: {
    borderTopLeftRadius: "18px",
    borderTopRightRadius: "18px",
    objectFit: 'cover',
  },
  button: {
    backgroundColor: "#2cc1e0",
    borderColor: "#30afca",
    borderRadius: "30px"
  },
  input: {
    borderRadius: "30px"
  },
  label: {
    fontSize: "14px"
  }
};

export default style;
